function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 6C0 2.68629 2.68629 0 6 0H22C25.3137 0 28 2.68629 28 6V22C28 25.3137 25.3137 28 22 28H6C2.68629 28 0 25.3137 0 22V6Z",
  fill: "#B8E1F6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 4.5C19.5078 4.5 24 8.99219 24 14.5C24 20.0078 19.5078 24.5 14 24.5C8.49219 24.5 4 20.0078 4 14.5C4 11.6875 5.17188 9.1875 7.00781 7.35156C7.51562 6.88281 8.29688 6.88281 8.76562 7.39062C9.23438 7.85938 9.23438 8.67969 8.76562 9.14844C7.35938 10.5156 6.5 12.3906 6.5 14.5C6.5 18.6406 9.85938 22 14 22C18.1406 22 21.5 18.6406 21.5 14.5C21.5 10.7891 18.8047 7.70312 15.25 7.11719V8.25C15.25 8.95312 14.7031 9.5 14 9.5C13.2969 9.5 12.75 8.95312 12.75 8.25V5.75C12.75 5.04688 13.2969 4.5 14 4.5ZM11.5391 10.7109L14.6641 13.8359C15.0156 14.1875 15.0156 14.8125 14.6641 15.1641C14.3125 15.5156 13.7266 15.5156 13.3359 15.1641L10.2109 12.0391C9.85938 11.6875 9.85938 11.0625 10.2109 10.7109C10.5625 10.3594 11.1875 10.3594 11.5391 10.7109Z",
  fill: "#006CA3"
});

function SvgDurationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurationIcon);
export default __webpack_public_path__ + "static/media/duration-icon.41b3917b.svg";
export { ForwardRef as ReactComponent };